import styled from 'styled-components';
import {mobileMedia} from '../../../../../../../globalVariables/GlobalVariables';
import {tokens} from '@tickchak/react-share/app';
import {
    dFlex, dInlineFlex, dFlexColumn, dFlexBetween, dFlexEnd,
    alignCenter, alignStart, alignEnd, justifyBetween
} from '../../../../../../../globalVariables/GlobalFlex';

export const tile = styled.div<{$active?: boolean}>`
  ${dFlexColumn}
  ${alignEnd}
  direction: ltr;
  width: 200px;
  box-sizing: border-box;
  background: var(--TA-color-bg-base);
  border: 1px solid var(--TA-color-border-subtle);
  border-radius: var(--radius-sm);
  padding: var(--space-lg);
  gap: var(--space-lg);
  color: var(--TA-color-text-default);
  ${mobileMedia}{ width: calc(50% - 4px); }
`;
export const tileTop = styled.div`
  ${dFlexColumn}
  ${alignStart}
  align-self: stretch;
  gap: var(--space-sm);
`;
export const statusRow = styled.div`
  ${dFlexBetween}
  align-self: stretch;
  gap: var(--space-xs);
`;
export const statusPill = styled.span`
  ${dInlineFlex}
  ${alignCenter}
  gap: var(--space-xs);
  padding: 3px var(--space-sm);
  border-radius: var(--radius-full);
  background: var(--TA-color-bg-surface-default);
  flex-shrink: 0;
`;
export const statusText = styled.span<{$active?: boolean}>`
  font-size: ${tokens.typography.fontSize.caption};
  line-height: 16px;
  color: ${p => p.$active ? 'var(--TA-color-state-success-main)' : 'var(--TA-color-text-subtle)'};
`;
export const statusDot = styled.span<{$c: string}>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${p => p.$c};
  flex-shrink: 0;
`;
export const assignee = styled.div<{$active?: boolean}>`
  ${dFlexEnd}
  gap: var(--space-xs);
  min-width: 0;
  font-size: ${tokens.typography.fontSize.caption};
  line-height: 16px;
  color: ${p => p.$active ? 'inherit' : 'var(--TA-color-text-disabled)'};
  span{ direction: ${p => p.theme.rtl ? 'rtl' : 'ltr'}; text-align: ${p => p.theme.rtl ? 'right' : 'left'}; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
`;
export const avatar = styled.div<{$image: string}>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid var(--TA-color-border-subtle);
  background: ${p => p.$image ? `url(${p.$image}) center/cover no-repeat` : 'var(--TA-color-bg-surface-default)'};
  flex-shrink: 0;
`;
export const avatarsStack = styled.div<{$active?: boolean}>`
  ${dInlineFlex}
  ${alignCenter}
  opacity: ${p => p.$active ? 1 : 0.5};
  & > *:not(:first-child){ margin-inline-start: calc(-1 * var(--space-xs)); }
`;
export const overflowBadge = styled.span`
  ${dInlineFlex}
  ${alignCenter}
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid var(--TA-color-border-subtle);
  background: var(--TA-color-bg-base);
  font-size: ${tokens.typography.fontSize.caption};
  font-weight: ${tokens.typography.fontWeight.bold};
  line-height: 1;
  color: var(--TA-color-text-default);
  flex-shrink: 0;
`;
export const tileTitle = styled.div<{$active?: boolean}>`
  align-self: stretch;
  direction: ${p => p.theme.rtl ? 'rtl' : 'ltr'};
  text-align: ${p => p.theme.rtl ? 'right' : 'left'};
  font-size: ${tokens.typography.fontSize.bodySmall};
  font-weight: ${tokens.typography.fontWeight.bold};
  line-height: 14px;
  min-height: 28px;
  color: ${p => p.$active ? 'var(--TA-color-text-default)' : 'var(--TA-color-text-disabled)'};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
export const tileBottom = styled.div`
  ${dFlexColumn}
  ${alignStart}
  align-self: stretch;
  gap: var(--space-xs);
`;
export const metaRow = styled.div`
  ${dFlex}
  ${alignEnd}
  ${justifyBetween}
  align-self: stretch;
  gap: var(--space-xs);
`;
export const percentGroup = styled.div`
  ${dFlex}
  align-items: baseline;
  gap: var(--space-xs);
  margin-inline-start: auto;
`;
export const soldOutBadge = styled.span`
  ${dInlineFlex}
  ${alignCenter}
  background: var(--primitive-gray-300);
  color: var(--TA-color-text-default);
  font-size: ${tokens.typography.fontSize.caption};
  line-height: 16px;
  border-radius: var(--radius-xs);
  padding: 4px var(--space-sm);
`;
export const unlimitedBadge = styled.span`
  ${dInlineFlex}
  ${alignCenter}
  background: var(--TA-color-state-info-bg);
  color: var(--TA-color-state-info-main);
  font-size: ${tokens.typography.fontSize.caption};
  font-weight: ${tokens.typography.fontWeight.regular};
  line-height: 16px;
  border-radius: var(--radius-xs);
  padding: 2px var(--space-sm);
  white-space: nowrap;
`;
export const tilePercent = styled.span`
  font-size: ${tokens.typography.fontSize.bodySmall};
  font-weight: ${tokens.typography.fontWeight.bold};
  line-height: 16.8px;
  color: var(--TA-color-text-default);
`;
export const tileCount = styled.span`
  font-size: ${tokens.typography.fontSize.caption};
  font-weight: ${tokens.typography.fontWeight.regular};
  line-height: 16px;
  color: var(--TA-color-text-subtle);
`;
export const countBold = styled.span`
  font-weight: ${tokens.typography.fontWeight.bold};
`;
export const progressTrack = styled.div`
  align-self: stretch;
  direction: ${p => p.theme.rtl ? 'rtl' : 'ltr'};
  height: 3px;
  border-radius: var(--radius-full);
  background: var(--TA-color-border-subtle);
  overflow: hidden;
`;
export const progressFill = styled.div<{$active?: boolean}>`
  height: 3px;
  border-radius: var(--radius-full);
  background: ${p => p.$active ? 'var(--TA-color-state-info-main)' : 'var(--primitive-gray-500)'};
`;
